export default __webpack_public_path__ + "68bb1372bc4f2e7cec53db3bac33bd5f.png";